// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyCrl-zT1fToyTuy6524OdLV0AOVsJcCMgo",
	authDomain: "st-demo-guestbook.firebaseapp.com",
	projectId: "st-demo-guestbook",
	storageBucket: "st-demo-guestbook.appspot.com",
	messagingSenderId: "179748444799",
	appId: "1:179748444799:web:8f74b9ef09d657c14d7d4a",
	measurementId: "G-EF05TPTDDF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);